// Configuration globale de la plateforme.
// Nom commercial décomposé en segments pour permettre une typographie
// bichromatique (ex: "Maak" en bleu / "Work" en rouge).
//
// Pour insérer un logo image, déposer le fichier dans /app/frontend/public/logo.png
// (formats également supportés : .svg, .webp — adapter PLATFORM_LOGO ci-dessous).
// Si le fichier n'existe pas, le composant <BrandMark/> retombe sur le monogramme.

export const PLATFORM_BRAND = [
  { text: "Maak", color: "#0055FF" },
  { text: "Work", color: "#EF4135" },
];

export const PLATFORM_NAME = PLATFORM_BRAND.map((p) => p.text).join(" "); // "Maak Work"
export const PLATFORM_INITIAL = PLATFORM_BRAND.map((p) => p.text.charAt(0).toUpperCase()).join(""); // "MW"
export const PLATFORM_TAGLINE = "Teams.Enterprises.Partners";

// Slot pour le logo de l'entreprise. Mettre à null pour cacher l'image
// et n'afficher que le monogramme. Si le fichier n'existe pas, le composant
// gérera silencieusement le fallback via onError.
export const PLATFORM_LOGO = "/logo.jpg";
